module.exports = __webpack_public_path__ + "img/videosdk-item-1.24117cc.png";